import * as React from "react";
import { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import "../Assets/Localization/i18n";
import { useLocation, useNavigate } from "react-router-dom";
import "./ModernLayout.css";

const MainLayout = ({ onSidebarToggle }) => {
  const [userEmail, setUserEmail] = useState("");
  const [userRole, setUserRole] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [isMobile, setIsMobile] = useState(false);
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const [activeMenu, setActiveMenu] = useState("/");
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const sidebarRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(width < 1024);
      if (width < 1024) {
        setSidebarOpen(false);
      } else {
        setSidebarOpen(true);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const email = localStorage.getItem("userEmail");
    const role = localStorage.getItem("userRole");

    if (email) {
      setUserEmail(email);
    }
    if (role) {
      setUserRole(role);
    }
  }, []);

  useEffect(() => {
    setActiveMenu(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    // Sidebar durumu değiştiğinde App.js'e bildir
    if (onSidebarToggle) {
      onSidebarToggle(isSidebarOpen);
    }
  }, [isSidebarOpen, onSidebarToggle]);

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("userRole");
    localStorage.removeItem("userEmail");
    window.location.href = "/login";
  };

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  const onSendMessageClick = () => {
    navigate("/sendmessage");
  };

  const onContactClick = () => {
    navigate("/contactus");
  };

  const menuItems = [
    {
      id: "01",
      text: t("Dashboard"),
      icon: "e-icons e-home",
      path: "/",
    },
    {
      id: "02",
      text: t("Accounts"),
      icon: "e-icons e-properties-2",
      path: "/accounts",
    },
    {
      id: "03",
      text: t("Contacts"),
      icon: "e-icons e-people",
      path: "/contacts",
    },
    {
      id: "05",
      text: t("Messages"),
      icon: "e-icons e-changes-accept",
      path: "/messages",
    },
    ...(userRole === "Admin" || userRole === "SuperAdmin"
      ? [
          {
            id: "07",
            text: t("Admins"),
            icon: "e-icons e-bullet-2",
            path: "/admins",
          },
          {
            id: "08",
            text: t("User Operations"),
            icon: "e-icons e-user",
            path: "/users",
          },
          {
            id: "09",
            text: t("User Transactions"),
            icon: "e-icons e-bullet-1",
            path: "/usertransactions",
          },
          {
            id: "10",
            text: t("Credits"),
            icon: "e-icons e-grid-view",
            path: "/credits",
          },
          {
            id: "11",
            text: t("Credit Settings"),
            icon: "e-icons e-field-settings",
            path: "/creditsettings",
          },
        ]
      : []),
    {
      id: "12",
      text: t("Settings"),
      icon: "e-icons e-settings",
      path: "/settings",
    },
  ];

  return (
    <>
      {/* Topbar */}
      <div className="modern-topbar">
        <div className="topbar-left">
          <button 
            className="menu-toggle-btn" 
            onClick={toggleSidebar}
            aria-label="Toggle menu"
          >
            <span className="e-icons e-menu"></span>
          </button>
          <div className="logo-container" onClick={() => navigate("/")}>
            <img src="/images/logo.png" alt="Logo" height="30" />
          </div>
        </div>

        <div className="topbar-right">
          <button 
            className="topbar-btn"
            onClick={onSendMessageClick}
            aria-label="Send Message"
          >
            <span className="e-icons e-send"></span>
            <span className="btn-text">{t("Send Message")}</span>
          </button>
          
          <button 
            className="topbar-btn"
            onClick={onContactClick}
            aria-label="Contact Us"
          >
            <span className="e-icons e-people"></span>
            <span className="btn-text">{t("Contact Us")}</span>
          </button>

          <div className="user-profile">
            <div className="user-info">
              <span className="user-email">{userEmail}</span>
              <span className="user-role">{userRole}</span>
            </div>
            <button 
              className="logout-btn" 
              onClick={handleLogout}
              aria-label="Logout"
            >
              <span className="e-icons e-close"></span>
            </button>
          </div>
        </div>
      </div>

      {/* Sidebar */}
      <div 
        ref={sidebarRef}
        className={`modern-sidebar ${isSidebarOpen ? 'open' : 'closed'}`}
      >
        <nav className="sidebar-menu">
          <ul>
            {menuItems.map((item) => (
              <li 
                key={item.id}
                className={activeMenu === item.path ? 'active' : ''}
                onClick={() => navigate(item.path)}
              >
                <span className={item.icon}></span>
                <span className="menu-text">{item.text}</span>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      {/* Main content wrapper - this surrounds the App.js main-content div */}
      <div className={`main-content-wrapper ${isSidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
        {/* Burada children/content olmayacak - App.js'deki Route'lar bunu kendi dolduracak */}
      </div>
    </>
  );
};

export default MainLayout;
